// extracted by mini-css-extract-plugin
export var container = "_5b-1";
export var editor = "_5b-2";
export var resizable = "_5b-3";
export var wrapper = "_5b-0";